const isImage = (card: CanvasCard.Card): card is CanvasCard.ImageCard =>
  card.content.type === 'Image';

export default isImage;
